export default __webpack_public_path__ + "static/media/Toplu_Emniyet_Cikis_Bildirimi.1a7ec7be.xlsx";